import React from 'react'
import logo from '../../Icons/softwaredevelopment.jpeg';
import AnimateOnScroll from '../../components/AnimateOnScroll';
import Padding from '../Padding';
import NavBar from '../NavBar';
import SEO from '../../components/SEO'
import Sales from '../Sales';

class MaintenanceSupport extends React.Component {
    render() {
      return (

      <div id='MaintenanceAndSupport' style={{backgroundColor: '#060a1f'}}>

        <NavBar/>
        <Padding/>
        <Padding/>
        <div className="container-text" style={{padding:"30px"}}>
            <h2>Maintenance And Support</h2>
            <div> 



<div className="generic-column" style={{ width: '100%' }}>
    <h3>Maintenance & Support</h3>
    <p>
        We can provide comprehensive post-deployment care, ensuring your  
        software and hardware systems remain secure, performant, and reliable 
        long after the initial commissioning.
    </p>

    <p>
        Our support framework is designed to minimise downtime and extend asset lifecycles:
    </p>

    <div className="usp-list">
 
        <div className="usp-item">
            <strong>Remote Diagnostics</strong>
            <span>
                Utilising secure VPN and industrial IoT gateways, we provide 
                rapid remote troubleshooting and software updates, resolving 
                technical issues without the delays associated with site visits.
            </span>
        </div>

        <div className="usp-item">
            <strong>Software Patching</strong>
            <span>
                We manage the ongoing security and stability of your systems, 
                ensuring that OS updates, database patches, and driver 
                optimisations are applied without disrupting your core processes.
            </span>
        </div>

        <div className="usp-item">
            <strong>Legacy System Care</strong>
            <span>
                Many facilities rely on ageing equipment. We specialise in 
                maintaining and supporting legacy software environments, 
                providing a bridge to modern standards while protecting your 
                existing capital investment.
            </span>
        </div>


    </div>
</div>




           </div>
        </div>

        <Padding/>
        <Padding/>

        <Sales/>
        <SEO/>
      </div>
  
      )
    }
  }

export default MaintenanceSupport;

